import { ColorContrastRequirements } from "client/Components/ColorPicker/BaseColorPicker";
import { IValueInputAttachable } from "client/Forms/attachable";
import { ReactElement } from "react";
import {
	BrandingImageConstraints,
	BrandingSettingsSaveModel,
} from "client/Api/Branding/branding";
import { LightTheme } from "./LightTheme";
import { DarkTheme } from "./DarkTheme";

export type ThemesTabProps = {
	attachable: IValueInputAttachable<BrandingSettingsSaveModel>;
	workspaceLogoId: string | null;
	publicPageLogoId: string | null;
	hasCustomBackgroundImage: boolean;
	onHasCustomBackgroundImageChange(newValue: boolean): void;
	workspaceBackgroundId: string | null;
	homeLogoId: string | null;
	logoConstraints: BrandingImageConstraints;
	backgroundConstraints: BrandingImageConstraints;
	darkThemePrimaryColorContrastRequirements: ColorContrastRequirements;
	darkThemeWorkspaceLogoId: string | null;
	darkThemePublicPageLogoId: string | null;
	darkThemeHomeLogoId: string | null;
};

export const ThemesTab = (props: ThemesTabProps): ReactElement => {
	const {
		attachable,
		darkThemeWorkspaceLogoId,
		darkThemePublicPageLogoId,
		darkThemeHomeLogoId,
		backgroundConstraints,
		homeLogoId,
		logoConstraints,
		publicPageLogoId,
		hasCustomBackgroundImage,
		onHasCustomBackgroundImageChange,
		workspaceBackgroundId,
		workspaceLogoId,
		darkThemePrimaryColorContrastRequirements
	} = props;

	return (
		<>
			<LightTheme
				attachable={attachable}
				logoConstraints={logoConstraints}
				backgroundConstraints={backgroundConstraints}
				homeLogoId={homeLogoId}
				publicPageLogoId={publicPageLogoId}
				hasCustomBackgroundImage={hasCustomBackgroundImage}
				onHasCustomBackgroundImageChange={onHasCustomBackgroundImageChange}
				workspaceBackgroundId={workspaceBackgroundId}
				workspaceLogoId={workspaceLogoId}
			/>
			<DarkTheme
				attachable={attachable.for("darkThemeSettings")}
				logoConstraints={logoConstraints}
				primaryColorContrastRequirements={darkThemePrimaryColorContrastRequirements}
				darkThemeHomeLogoId={darkThemeHomeLogoId}
				darkThemePublicPageLogoId={darkThemePublicPageLogoId}
				darkThemeWorkspaceLogoId={darkThemeWorkspaceLogoId}
			/>
		</>
	);
};
ThemesTab.displayName = "ThemesTab";